export default (function (siteVars) {
  return {
    zIndex: 1000,
    contentColor: siteVars.colorScheme.default.foreground,
    contentBackgroundColor: siteVars.colorScheme.default.background
  };
});